var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 4,
    x2: 14,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 4,
    x2: 22,
    y2: 4,
    stroke: "black",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 20,
    x2: 22,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 4,
    x2: 2,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 4,
    x2: 22,
    y2: 20,
    stroke: "black",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.7581c17efc73bbdbf946203dfc08f4f8.svg";
export { ForwardRef as ReactComponent };